import { Link } from "react-router-dom";
import { Play, Pause, Clock } from "lucide-react";
import { usePlayer } from "@/context/PlayerContext";
import { formatDate, formatDuration } from "@/lib/podcast";

export default function EpisodeCard({ ep }) {
  const { playEpisode, toggle, isActive, isPlaying } = usePlayer();
  const active = isActive(ep);

  return (
    <article
      data-testid={`episode-card-${ep.slug}`}
      className="group flex flex-col bg-white rounded-md overflow-hidden border border-[#0b1f4d]/10 transition-all duration-200 ease-out hover:-translate-y-1 hover:border-[#f5b61c]/60 hover:shadow-[0_10px_40px_-12px_rgba(245, 182, 28,0.35)]"
    >
      <Link
        to={`/episodes/${ep.slug}`}
        className="relative block aspect-square overflow-hidden"
      >
        <img
          src={ep.image}
          alt={ep.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </Link>

      <div className="flex flex-col flex-1 p-5">
        <div className="flex items-center gap-3 text-xs font-mono uppercase tracking-widest text-[#66718d] mb-2">
          <span>{formatDate(ep.pubDate)}</span>
          <span className="inline-flex items-center gap-1">
            <Clock size={12} /> {formatDuration(ep.durationSeconds)}
          </span>
        </div>

        <Link to={`/episodes/${ep.slug}`}>
          <h3 className="font-display uppercase text-xl font-semibold leading-snug text-[#0b1f4d] group-hover:text-[#9a6700] transition-colors">
            {ep.title}
          </h3>
        </Link>

        <p className="mt-2 text-sm text-[#4d5a78] leading-relaxed line-clamp-3">
          {ep.excerpt}
        </p>

        <div className="mt-4 pt-4 border-t border-[#0b1f4d]/10 flex items-center gap-3">
          <button
            data-testid={`card-play-${ep.slug}`}
            onClick={() => (active ? toggle() : playEpisode(ep))}
            className="inline-flex items-center gap-2 rounded-sm bg-[#f5b61c] hover:bg-[#dda00d] text-[#0a1630] text-sm font-semibold uppercase tracking-wide px-4 py-2 transition-colors"
          >
            {active && isPlaying ? (
              <>
                <Pause size={15} /> Playing
              </>
            ) : (
              <>
                <Play size={15} /> Play
              </>
            )}
          </button>
          <Link
            to={`/episodes/${ep.slug}`}
            data-testid={`card-notes-${ep.slug}`}
            className="text-sm font-semibold text-[#374566] hover:text-[#9a6700] transition-colors"
          >
            Show notes →
          </Link>
        </div>
      </div>
    </article>
  );
}
